import { useRef, useState } from 'react';

// SignaturePad: Unterschrift mit Finger, Stift oder Maus. onChange liefert das Bild als PNG (data-URL) bzw. null.
export function SignaturePad({ onChange }: { onChange: (png: string | null) => void }) {
  const canvas = useRef<HTMLCanvasElement>(null);
  const drawing = useRef(false);
  const last = useRef<{ x: number; y: number } | null>(null);
  const strokes = useRef(0);
  const [empty, setEmpty] = useState(true);

  const point = (e: React.PointerEvent<HTMLCanvasElement>) => {
    const c = e.currentTarget;
    const r = c.getBoundingClientRect();
    return { x: ((e.clientX - r.left) * c.width) / (r.width || c.width), y: ((e.clientY - r.top) * c.height) / (r.height || c.height) };
  };
  const ctx = () => {
    const c = canvas.current?.getContext('2d');
    if (c) {
      c.lineWidth = 3;
      c.lineCap = 'round';
      c.lineJoin = 'round';
      c.strokeStyle = getComputedStyle(document.documentElement).getPropertyValue('--color-text').trim() || 'black';
    }
    return c;
  };
  const finish = () => {
    if (!drawing.current) return;
    drawing.current = false;
    last.current = null;
    strokes.current += 1;
    setEmpty(false);
    onChange(canvas.current?.toDataURL('image/png') ?? null);
  };
  const clear = () => {
    const c = canvas.current;
    c?.getContext('2d')?.clearRect(0, 0, c.width, c.height);
    strokes.current = 0;
    setEmpty(true);
    onChange(null);
  };

  return (
    <div className="signature-pad">
      <canvas
        ref={canvas}
        width={600}
        height={200}
        aria-label="Unterschriftsfeld"
        onPointerDown={(e) => {
          e.currentTarget.setPointerCapture?.(e.pointerId);
          drawing.current = true;
          last.current = point(e);
        }}
        onPointerMove={(e) => {
          if (!drawing.current || !last.current) return;
          const p = point(e);
          const c = ctx();
          if (c) {
            c.beginPath();
            c.moveTo(last.current.x, last.current.y);
            c.lineTo(p.x, p.y);
            c.stroke();
          }
          last.current = p;
        }}
        onPointerUp={finish}
        onPointerLeave={finish}
      />
      <div className="signature-pad-actions">
        <span className="muted small">{empty ? 'Bitte hier unterschreiben' : 'Unterschrift erfasst'}</span>
        <button type="button" className="btn btn-small" onClick={clear} disabled={empty}>
          Löschen
        </button>
      </div>
    </div>
  );
}
